import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Button } from "../../_global";
import { GridTemplate, CenteredGridFooter } from "./style";
var OfferGrid = /*#__PURE__*/function (_Component) {
  function OfferGrid() {
    var _this;
    _classCallCheck(this, OfferGrid);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, OfferGrid, [].concat(args)), _this.state = {
      isShowingMore: false
    }, _this.showMore = function () {
      _this.setState({
        isShowingMore: true
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(OfferGrid, _Component);
  return _createClass(OfferGrid, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        showMoreText = _this$props.showMoreText,
        defaultItems = _this$props.defaultItems;
      var gridItems = React.Children.toArray(children);
      var enableShowMore = this.props.enableShowMore && gridItems.length > defaultItems + 1;
      var isShowingMore = this.state.isShowingMore;
      return __jsx("div", null, __jsx(GridTemplate, this.props, enableShowMore && !isShowingMore ? gridItems.slice(0, defaultItems + 1).map(function (item) {
        return item;
      }) : children), enableShowMore && !isShowingMore && __jsx(CenteredGridFooter, null, __jsx(Button, {
        onClick: this.showMore,
        outline: true,
        large: true
      }, showMoreText)));
    }
  }]);
}(Component);
OfferGrid.defaultProps = {
  enableShowMore: false,
  showMoreText: 'More',
  defaultItems: 4,
  hasHow: true
};
export default OfferGrid;